import {
  Box, Button, Grid, Modal, Stack, Typography,
} from '@mui/material';
import BlockSettings, { BlockAlign, BlockJustify } from '../../../models/BlockSettings';
import BlockAlignPicker from './components/BlockAlignPicker';
import BlockJustifyPicker from './components/BlockJustifyPicker';

interface BlockSettingsModalProps {
  openModal: boolean;
  settings: BlockSettings;
  hideAlign?: boolean;
  hideJustify?: boolean;
  direction: 'row' | 'column';
  onChangeAlign?: (target: BlockAlign) => void;
  onChangeJustify?: (target: BlockJustify) => void;
  onCloseModal: () => void;
  onSaveModal: () => void;
}

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '70%',
  height: 'auto',
  bgcolor: 'background.paper',
  borderRadius: '0.5rem !important',
  boxShadow: 24,
};

const headerStyle = {
  borderTopLeftRadius: '0.5rem !important',
  borderTopRightRadius: '0.5rem !important',
  backgroundColor: '#dce0e5',
  borderBottom: '1px solid #ccc',
  padding: '12px',
};

const contentStyle = {
  padding: '12px',
};

const footerStyle = {
  padding: '12px',
};

function BlockSettingsModal({
  openModal,
  settings,
  hideAlign,
  hideJustify,
  direction,
  onChangeAlign,
  onChangeJustify,
  onCloseModal,
  onSaveModal,
}: BlockSettingsModalProps) {
  return (
    <Modal
      open={openModal}
      onClose={onCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {/* Modal Header */}
        <Typography variant="subtitle2" className="modal-title" sx={headerStyle}>
          Layout Settings
        </Typography>

        <div style={contentStyle}>
          <Grid
            container
            direction="column"
            alignItems="start"
            justifyContent="center"
            sx={{
              p: 2,
              border: '1px dashed lightGray',
              position: 'relative',
            }}
          >
            {!hideAlign && (
              <Grid item sx={{ my: 1 }}>
                <BlockAlignPicker value={settings.align} direction={direction} onChangeAlign={(value) => onChangeAlign(value)} />
              </Grid>
            )}
            {!hideJustify && (
              <Grid item sx={{ my: 1 }}>
                <BlockJustifyPicker value={settings.justify} direction={direction} onChangeJustify={(value) => onChangeJustify(value)} />
              </Grid>
            )}
          </Grid>
        </div>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          mt={2}
          style={footerStyle}
          borderTop={1}
          borderColor="#dee2e6"
        >
          <Button variant="outlined" color="primary" onClick={onCloseModal}>
            Cancel
          </Button>

          <Button variant="contained" color="primary" onClick={onSaveModal}>
            Apply
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}

export default BlockSettingsModal;
